/* ca89-shop.js — Wishlist, Compare, Quick View, Registry, Add to Cart */
(function () {
  'use strict';

  var SK = { WISH: 'ca89-wishlist', CMP: 'ca89-compare', REG: 'ca89-registries' };
  var state = { wish: [], cmp: [], regs: [], _regProduct: null };

  /* ---- Storage ---- */
  function load() {
    try { state.wish = JSON.parse(localStorage.getItem(SK.WISH) || '[]'); } catch(e) { state.wish = []; }
    try { state.cmp  = JSON.parse(localStorage.getItem(SK.CMP)  || '[]'); } catch(e) { state.cmp  = []; }
    try { state.regs = JSON.parse(localStorage.getItem(SK.REG)  || '[]'); } catch(e) { state.regs = []; }
  }
  load(); // populate state immediately so window.CA89Shop APIs are ready
  function saveWish() { localStorage.setItem(SK.WISH, JSON.stringify(state.wish)); }
  function saveCmp()  { localStorage.setItem(SK.CMP,  JSON.stringify(state.cmp));  }
  function saveRegs() { localStorage.setItem(SK.REG,  JSON.stringify(state.regs)); refreshRegistryBadge(); }

  function refreshRegistryBadge() {
    var badge = document.querySelector('[data-registry-badge]');
    if (!badge) return;
    var n = state.regs.length;
    badge.textContent = n;
    badge.style.display = n === 0 ? 'none' : 'flex';
  }

  /* ---- Card data ---- */
  function cardData(card) {
    if (!card) return null;
    return {
      id:          card.dataset.productId,
      title:       card.dataset.productTitle,
      price:       card.dataset.productPrice,
      image:       card.dataset.productImage,
      url:         card.dataset.productUrl,
      description: card.dataset.productDescription,
      rating:      card.dataset.productRating,
      ratingCount: card.dataset.productRatingCount,
      variantId:   card.dataset.variantId,
      category:    card.dataset.productCategory
    };
  }

  /* ---- Escape html ---- */
  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ====== WISHLIST ====== */
  function inWish(id) { return state.wish.some(function(p){ return p.id === id; }); }

  function toggleWish(id, data) {
    var i = state.wish.findIndex(function(p){ return p.id === id; });
    var added = false;
    if (i > -1) { state.wish.splice(i,1); } else { state.wish.push(data); added = true; }
    saveWish();
    refreshWishButtons();
    refreshHeaderBadge();
    var btn = document.querySelector('[data-action="wishlist"][data-target-id="'+id+'"]') ||
              document.querySelector('.spr-card[data-product-id="'+id+'"] [data-action="wishlist"]');
    if (btn) bumpBtn(btn);
    showToast(added ? 'Added to wishlist' : 'Removed from wishlist', 'heart');
  }

  function refreshWishButtons() {
    document.querySelectorAll('[data-action="wishlist"]').forEach(function(btn) {
      var card = btn.closest('.spr-card');
      if (card) btn.classList.toggle('spr-btn-w-active', inWish(card.dataset.productId));
    });
    var qvHeart = document.querySelector('[data-qv-field="heart"]');
    if (qvHeart && qvHeart.dataset.productId) {
      qvHeart.classList.toggle('spr-btn-w-active', inWish(qvHeart.dataset.productId));
    }
  }

  function refreshHeaderBadge() {
    var badge = document.querySelector('[data-wishlist-badge]');
    if (badge) {
      var n = state.wish.length;
      badge.textContent = n;
      badge.style.display = n === 0 ? 'none' : 'flex';
    }
    var drawerCount = document.querySelector('[data-wishlist-drawer-count]');
    if (drawerCount) {
      drawerCount.textContent = '(' + state.wish.length + ')';
    }
  }

  /* ====== COMPARE ====== */
  function inCmp(id) { return state.cmp.some(function(p){ return p.id === id; }); }

  function toggleCmp(id, data) {
    var i = state.cmp.findIndex(function(p){ return p.id === id; });
    var added = false;
    if (i > -1) { state.cmp.splice(i,1); }
    else {
      if (state.cmp.length >= 4) { showToast('Compare list is full (max 4)'); return; }
      state.cmp.push(data);
      added = true;
    }
    saveCmp();
    refreshCmpButtons();
    var btn = document.querySelector('.spr-card[data-product-id="'+id+'"] [data-action="compare"]');
    if (btn) bumpBtn(btn);
    showToast(added ? 'Added to compare' : 'Removed from compare', 'compare');
    renderCmpBar();
  }

  function refreshCmpButtons() {
    document.querySelectorAll('[data-action="compare"]').forEach(function(btn) {
      var card = btn.closest('.spr-card');
      if (card) btn.classList.toggle('spr-btn-c-active', inCmp(card.dataset.productId));
    });
  }

  function clearCmp() {
    state.cmp = [];
    saveCmp();
    refreshCmpButtons();
    renderCmpBar();
  }

  function renderCmpBar() {
    var bar = document.getElementById('ca89-compare-bar');
    if (!bar) return;
    if (state.cmp.length === 0) { bar.classList.add('hidden'); return; }
    bar.classList.remove('hidden');

    var ids = state.cmp.map(function(p){ return p.id; }).join(',');
    ['ca89-compare-now','ca89-compare-now-mobile'].forEach(function(elId) {
      var el = document.getElementById(elId);
      if (el) el.href = '/pages/ca89v2-compare?ids=' + ids;
    });

    document.querySelectorAll('[data-compare-count]').forEach(function(el) {
      el.textContent = state.cmp.length;
    });

    function buildChip(p, mobile) {
      var d = document.createElement('div');
      d.className = mobile ? 'cmp-chip-m' : 'cmp-chip-d';
      d.innerHTML = '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" style="width:' + (mobile?'32px':'40px') + ';height:' + (mobile?'32px':'40px') + ';">'
        + (mobile ? '<span style="font-size:10px;font-weight:500;overflow:hidden;white-space:nowrap;max-width:60px;">' + esc(p.title) + '</span>'
                  : '<div style="min-width:0;"><p style="font-size:12px;font-weight:500;color:#1a1a1a;overflow:hidden;white-space:nowrap;max-width:120px;">' + esc(p.title) + '</p><p style="font-size:10px;color:#c9a962;">' + esc(p.price) + '</p></div>')
        + '<button type="button" class="cmp-remove" data-compare-remove="' + esc(p.id) + '" aria-label="Remove">'
        + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
      return d;
    }

    var desk = document.getElementById('ca89-compare-items-desktop');
    var mob  = document.getElementById('ca89-compare-items-mobile');
    if (desk) { desk.innerHTML = ''; state.cmp.forEach(function(p){ desk.appendChild(buildChip(p, false)); }); }
    if (mob)  { mob.innerHTML  = ''; state.cmp.forEach(function(p){ mob.appendChild(buildChip(p, true));  }); }
  }

  /* ====== QUICK VIEW ====== */
  function openQV(data) {
    var m = document.getElementById('ca89-qv-modal');
    if (!m) return;

    function set(sel, val) {
      var el = m.querySelector('[data-qv-field="' + sel + '"]');
      if (el) el.textContent = val;
    }
    function setAttr(sel, attr, val) {
      var el = m.querySelector('[data-qv-field="' + sel + '"]');
      if (el) el[attr] = val;
    }

    setAttr('image', 'src', data.image);
    setAttr('image', 'alt', data.title);
    set('title', data.title);
    set('price', data.price);
    set('description', data.description);

    var rWrap = m.querySelector('[data-qv-field="rating-wrap"]');
    if (rWrap) {
      rWrap.classList.toggle('hidden', !data.rating);
      if (data.rating) { set('rating', data.rating); set('rating-count', data.ratingCount); }
    }

    var heart = m.querySelector('[data-qv-field="heart"]');
    if (heart) {
      heart.dataset.productId    = data.id;
      heart.dataset.productTitle = data.title;
      heart.dataset.productPrice = data.price;
      heart.dataset.productImage = data.image;
      heart.dataset.productUrl   = data.url;
      heart.classList.toggle('spr-btn-w-active', inWish(data.id));
    }

    var atcBtn = m.querySelector('[data-qv-field="atc"]');
    if (atcBtn) { atcBtn.dataset.variantId = data.variantId; atcBtn.dataset.productTitle = data.title; }

    var dLink = m.querySelector('[data-qv-field="details-link"]');
    if (dLink) dLink.href = data.url;

    m.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeQV() {
    var m = document.getElementById('ca89-qv-modal');
    if (m) m.classList.add('hidden');
    document.body.style.overflow = '';
  }

  /* ====== REGISTRY ====== */
  function openReg(data) {
    state._regProduct = data;
    var m = document.getElementById('ca89-reg-modal');
    if (!m) return;
    var img   = m.querySelector('[data-reg-field="image"]');
    var title = m.querySelector('[data-reg-field="title"]');
    var price = m.querySelector('[data-reg-field="price"]');
    if (img)   { img.src = data.image; img.alt = data.title; }
    if (title)   title.textContent = data.title;
    if (price)   price.textContent = data.price;
    setRegMode('select');
    m.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeReg() {
    var m = document.getElementById('ca89-reg-modal');
    if (m) m.classList.add('hidden');
    document.body.style.overflow = '';
    state._regProduct = null;
    var form = document.getElementById('ca89-reg-form');
    if (form) form.reset();
  }

  function setRegMode(mode) {
    var m = document.getElementById('ca89-reg-modal');
    if (!m) return;
    var titles = { select:'Add to Registry', create:'Create Registry', added:'Added!' };
    var titleEl = m.querySelector('[data-reg-field="modal-title"]');
    if (titleEl) titleEl.textContent = titles[mode] || 'Add to Registry';

    var summary = m.querySelector('[data-reg-panel="summary"]');
    if (summary) summary.classList.toggle('hidden', mode === 'added');

    ['select','create','added'].forEach(function(md) {
      var p = m.querySelector('[data-reg-panel="' + md + '"]');
      if (p) p.classList.toggle('hidden', md !== mode);
    });

    if (mode === 'select') renderRegList();
  }

  function renderRegList() {
    var listEl  = document.getElementById('ca89-reg-list');
    var emptyEl = document.getElementById('ca89-reg-empty');
    if (!listEl || !emptyEl) return;
    if (state.regs.length === 0) {
      emptyEl.classList.remove('hidden'); listEl.classList.add('hidden');
    } else {
      emptyEl.classList.add('hidden'); listEl.classList.remove('hidden');
      listEl.innerHTML = '';
      state.regs.forEach(function(r) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'w-full flex items-center gap-4 p-4 bg-[#f8f7f5] border border-[#e5e5e5] hover:border-[#c9a962] transition-all text-left';
        btn.dataset.registryId = r.id;
        btn.innerHTML = '<svg class="w-5 h-5 text-[#c9a962]" style="flex-shrink:0;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>'
          + '<div style="flex:1;min-width:0;"><p style="font-size:14px;font-weight:500;overflow:hidden;white-space:nowrap;">' + esc(r.name) + '</p><p style="font-size:11px;color:rgba(26,26,26,.5);">' + esc(r.eventType) + ' &bull; ' + r.items.length + ' items</p></div>'
          + '<svg class="w-4 h-4 text-[#c9a962]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
        listEl.appendChild(btn);
      });
    }
  }

  function addToReg(registryId) {
    var p = state._regProduct;
    if (!p) return;
    var r = state.regs.find(function(x){ return x.id === registryId; });
    if (!r) return;
    r.items.push({ productId: p.id, name: p.title, price: p.price, image: p.image, url: p.url || '', variantId: p.variantId || '', quantity: 1, purchased: 0 });
    saveRegs();
    setRegMode('added');
    setTimeout(closeReg, 1500);
  }

  function createAndAddReg(data) {
    var id = 'reg_' + Date.now();
    state.regs.push({ id: id, name: data.name, eventType: data.eventType, eventDate: data.eventDate, message: data.message, items: [], createdAt: new Date().toISOString() });
    saveRegs();
    addToReg(id);
  }

  /* ====== ADD TO CART ====== */
  function addToCart(variantId, title, onSuccess) {
    if (!variantId) { showToast('Product not available'); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function(r) {
      if (!r.ok) throw new Error();
      return r.json();
    }).then(function() {
      showToast((title ? '"' + title + '"' : 'Item') + ' added to cart', 'success');
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      }).catch(function(){});
      if (onSuccess) onSuccess();
    }).catch(function() {
      showToast('Could not add to cart. Please try again.');
    });
  }

  /* ====== TOAST ====== */
  var toastTimer;
  function showToast(msg, variant) {
    var t = document.getElementById('ca89-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ca89-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:9999;background:#1a1a1a;color:#fff;padding:14px 20px;font-family:"IBM Plex Mono",monospace;font-size:11px;letter-spacing:.1em;opacity:0;transform:translateX(20px);transition:opacity .3s cubic-bezier(.165,.84,.44,1),transform .3s cubic-bezier(.165,.84,.44,1);pointer-events:none;max-width:320px;display:flex;align-items:center;gap:10px;box-shadow:0 10px 30px rgba(0,0,0,.2);border-left:3px solid #c9a962;';
      document.body.appendChild(t);
    }
    var iconSvg = '';
    if (variant === 'success') {
      iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c9a962" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if (variant === 'heart') {
      iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="#c9a962" stroke="#c9a962" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    } else if (variant === 'compare') {
      iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c9a962" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m17 3 4 4-4 4"/><path d="M21 7H3"/><path d="m7 21-4-4 4-4"/><path d="M3 17h18"/></svg>';
    }
    t.innerHTML = iconSvg + '<span>' + String(msg || '').replace(/</g,'&lt;') + '</span>';
    requestAnimationFrame(function(){
      t.style.opacity = '1';
      t.style.transform = 'translateX(0)';
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){
      t.style.opacity = '0';
      t.style.transform = 'translateX(20px)';
    }, 2500);
  }

  function bumpBtn(el) {
    if (!el) return;
    el.style.transition = 'transform .2s cubic-bezier(.34,1.56,.64,1)';
    el.style.transform = 'scale(1.25)';
    setTimeout(function(){ el.style.transform = 'scale(1)'; }, 200);
  }

  /* ====== EVENT DELEGATION ====== */
  document.addEventListener('click', function(e) {
    /* Action buttons */
    var btn = e.target.closest('[data-action]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var action = btn.dataset.action;
      var card   = btn.closest('.spr-card');
      var data   = card ? cardData(card) : null;

      if (action === 'view'      && data) { window.location.href = data.url; return; }
      if (action === 'wishlist'  && data) { toggleWish(data.id, data); return; }
      if (action === 'compare'   && data) { toggleCmp(data.id, data); return; }
      if (action === 'quickview' && data) { openQV(data); return; }
      if (action === 'registry'  && data) { openReg(data); return; }

      if (action === 'atc') {
        var vid = btn.dataset.variantId || (card && card.dataset.variantId);
        var ttl = btn.dataset.productTitle || (card && card.dataset.productTitle);
        addToCart(vid, ttl);
        return;
      }
      if (action === 'qv-atc') {
        addToCart(btn.dataset.variantId, btn.dataset.productTitle, closeQV);
        return;
      }
      if (action === 'qv-heart') {
        var pid = btn.dataset.productId;
        if (pid) {
          toggleWish(pid, { id: pid, title: btn.dataset.productTitle, price: btn.dataset.productPrice, image: btn.dataset.productImage, url: btn.dataset.productUrl });
          btn.classList.toggle('spr-btn-w-active', inWish(pid));
        }
        return;
      }
    }

    /* Compare remove chip */
    var rmBtn = e.target.closest('[data-compare-remove]');
    if (rmBtn) {
      e.preventDefault(); e.stopPropagation();
      var rmId = rmBtn.dataset.compareRemove;
      var idx  = state.cmp.findIndex(function(p){ return p.id === rmId; });
      if (idx > -1) { state.cmp.splice(idx,1); saveCmp(); refreshCmpButtons(); renderCmpBar(); }
      return;
    }

    /* Compare clear */
    if (e.target.closest('#ca89-compare-clear')) {
      e.preventDefault();
      console.log('[Shop] Clear button clicked, cmp before:', state.cmp.length);
      clearCmp();
      console.log('[Shop] Clear button clicked, cmp after:', state.cmp.length);
      return;
    }

    /* QV close */
    var qvM = document.getElementById('ca89-qv-modal');
    if (qvM) {
      if (e.target === qvM || e.target.closest('[data-qv-close]')) { closeQV(); return; }
    }

    /* Registry close / backdrop */
    var rM = document.getElementById('ca89-reg-modal');
    if (rM) {
      if (e.target === rM || e.target.closest('[data-reg-close]')) { closeReg(); return; }
    }

    /* Registry: select existing */
    var regItem = e.target.closest('[data-registry-id]');
    if (regItem) { addToReg(regItem.dataset.registryId); return; }

    /* Registry mode buttons */
    var regAct = e.target.closest('[data-reg-action]');
    if (regAct) {
      e.preventDefault();
      var a = regAct.dataset.regAction;
      if (a === 'create')   setRegMode('create');
      if (a === 'back')     setRegMode('select');
      if (a === 'continue') closeReg();
      return;
    }
  });

  /* Registry form submit */
  document.addEventListener('submit', function(e) {
    if (!e.target.closest('#ca89-reg-form')) return;
    e.preventDefault();
    var f = e.target.closest('#ca89-reg-form');
    var name  = f.querySelector('#ca89-reg-name').value.trim();
    var eDate = f.querySelector('#ca89-reg-event-date').value;
    if (!name || !eDate) return;
    createAndAddReg({
      name:      name,
      eventType: f.querySelector('#ca89-reg-event-type').value,
      eventDate: eDate,
      message:   f.querySelector('#ca89-reg-message').value.trim()
    });
  });

  /* ESC key */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var qvM = document.getElementById('ca89-qv-modal');
    if (qvM && !qvM.classList.contains('hidden')) { closeQV(); return; }
    var rM  = document.getElementById('ca89-reg-modal');
    if (rM  && !rM.classList.contains('hidden'))  { closeReg();  return; }
  });

  /* ====== INIT ====== */
  function init() {
    load();
    refreshWishButtons();
    refreshCmpButtons();
    renderCmpBar();
    refreshHeaderBadge();
    refreshRegistryBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CA89Shop = {
    toggleWish:      toggleWish,
    toggleCmp:       toggleCmp,
    openQV:          openQV,
    openReg:         openReg,
    addToCart:       addToCart,
    clearCompare:    clearCmp,
    showToast:       showToast,
    bumpBtn:         bumpBtn,
    removeCmp:       function(id) {
      var i = state.cmp.findIndex(function(p){ return p.id === id; });
      if (i > -1) { state.cmp.splice(i,1); saveCmp(); refreshCmpButtons(); renderCmpBar(); }
    },
    getCompareList:  function() { return state.cmp.slice(); },
    removeWish:      function(id) {
      var i = state.wish.findIndex(function(p){ return p.id === id; });
      if (i > -1) { state.wish.splice(i,1); saveWish(); refreshWishButtons(); refreshHeaderBadge(); }
    },
    getWishlist:     function() { return state.wish.slice(); },
    getRegistries:   function() { return state.regs.slice(); },
    findRegistry:    function(id) { return state.regs.find(function(r){ return r.id === id; }); },
    deleteRegistry:  function(id) {
      var i = state.regs.findIndex(function(r){ return r.id === id; });
      if (i > -1) { state.regs.splice(i,1); saveRegs(); }
    },
    createRegistry:  function(data) {
      var id = 'reg_' + Date.now();
      state.regs.push({ id: id, name: data.name, eventType: data.eventType, eventDate: data.eventDate, message: data.message, items: [], createdAt: new Date().toISOString() });
      saveRegs();
      return id;
    }
  };
})();
